import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

export const shouldUseResumption = (action: MessageAction): boolean =>
	action.resumptionAvailable === true;

export const resolveResumptionEligibility = (actions: MessageAction[]): boolean =>
	actions.length > 0 && actions.every(shouldUseResumption);
